import { Box } from '@mui/material'
import { styled } from '@mui/material/styles'

// Create a styled component for the background Box
const StyledOvalOverlay = styled(Box)(({ theme }) => ({
  zIndex: 2,
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
  height: '750px',
  // height: '100%',
  backgroundImage: 'url("/images/oval-grey.png")',
  backgroundSize: 'cover',
  backgroundPosition: 'top',
  backgroundRepeat: 'no-repeat',
  [theme.breakpoints.down('sm')]: {
    height: '750px',
    backgroundSize: '160%',
  },
  [theme.breakpoints.down('xs')]: {
    height: '700px',
    backgroundSize: '180%',
  },
  [theme.breakpoints.down(385)]: {
    height: '560px',
    backgroundSize: '160%',
  },
}))
export default StyledOvalOverlay
